import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

interface StyledProps {
  secondary?: boolean;
  disabled?: boolean
}

const BUTTON_CONTENT_HEIGHT = '38px';

const StyledLabel = styled.label<StyledProps>`
  ${({ theme, secondary, disabled }) => {
    if (disabled) {
      return {
        backgroundColor: theme.colors.buttonPrimaryDisabled,
        cursor: 'not-allowed',
      };
    }

    if (secondary) {
      return {
        backgroundColor: theme.colors.buttonTertiaryHover,
        cursor: 'pointer',
      };
    }

    return {
      backgroundColor: theme.colors.buttonPrimary,
      cursor: 'pointer',
    };
  }}

  padding-block: ${({ theme }) => theme.spacings.spacing8};
  border-radius: ${({ theme }) => theme.rounds.container2Round};
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: all 0.3s;

  &:hover {
    ${({ theme, secondary, disabled }) => {
      if (disabled) {
        return {
          backgroundColor: theme.colors.buttonPrimaryDisabled,
        };
      }

      if (secondary) {
        return {
          backgroundColor: theme.colors.buttonTertiaryPressed,
        };
      }

      return {
        backgroundColor: theme.colors.textAccentHover,
      };
    }}
  }

  &:active {
    ${({ theme, secondary, disabled }) => {
      if (disabled) {
        return {
          backgroundColor: theme.colors.buttonPrimaryDisabled,
        };
      }

      if (secondary) {
        return {
          backgroundColor: theme.colors.buttonTertiaryPressed,
        };
      }

      return {
        backgroundColor: theme.colors.textAccentActive,
      };
    }}
  }
`;

export interface FileGetAndUploadButtonProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (event: any) => void;
  title?: string;
  id: string;
  testId?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  cameraInput?: boolean;
  secondary?: boolean;
  isRightIconPosition?: boolean;
  accept?: string;
  disabled?: boolean;
}

export const FileGetAndUploadButton: React.FC<FileGetAndUploadButtonProps> = ({
  onChange,
  title,
  id,
  children,
  testId,
  cameraInput,
  secondary,
  icon,
  isRightIconPosition,
  accept = 'image/*',
  disabled,
}) => (
  <StyledLabel
    htmlFor={`file-upload-for-${id}`}
    data-testid={`file-upload-for-${id}`}
    secondary={secondary}
    disabled={disabled}
  >
    <Box direction="row" justify="center" align="center" height={BUTTON_CONTENT_HEIGHT}>
      {!isRightIconPosition && icon}
      <Inscription
        size="14px"
        weight={700}
        color={secondary ? 'textBody' : 'canvas'}
        lineHeight="20px"
        margin={icon ? (isRightIconPosition ? { right: 'spacing8' } : { left: 'spacing8' }) : {}}
      >
        {children}
        {title}
      </Inscription>
      {isRightIconPosition && icon}
    </Box>
    <input
      id={`file-upload-for-${id}`}
      type="file"
      accept={accept}
      onChange={onChange}
      style={{ display: 'none' }}
      data-testid={`${testId}_upload-button`}
      {...(cameraInput && { capture: 'environment' })}
      disabled={disabled}
    />
  </StyledLabel>
);
